export default "__VITE_ASSET__CwSm26A8__"